/**
 * Gewinnspiel header: hide on scroll down, show on scroll up
 * + menu scroll-spy: adds .is-active to the menu link when its section is in view
 * + burger menu drawer: opens/closes drawer on burger click
 */
(function () {
  const headerInner = document.querySelector('.gewinnspiel-header__inner');
  const burger = document.querySelector('.gewinnspiel-header__burger');
  const drawer = document.getElementById('gewinnspiel-drawer');
  const backdrop = document.querySelector('.gewinnspiel-header__drawer-backdrop');
  const closeBtn = document.querySelector('.gewinnspiel-header__drawer-close');
  const drawerLinks = document.querySelectorAll('.gewinnspiel-header__menu--drawer .gewinnspiel-header__menu-link');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) {
      burger.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  function toggleDrawer() {
    if (drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  if (burger && drawer) {
    burger.addEventListener('click', toggleDrawer);
  }
  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }
  drawerLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 1000px)').matches && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateHeaderVisibility() {
    if (!headerInner) return;
    const scrollY = window.scrollY;
    if (scrollY > lastScrollY && scrollY > 80) {
      headerInner.classList.add('is-hidden');
    } else {
      headerInner.classList.remove('is-hidden');
    }
    lastScrollY = scrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateHeaderVisibility);
    }
  }

  if (headerInner) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const links = document.querySelectorAll('.gewinnspiel-header__menu-link[data-section-anchor]');
  const sections = [];

  links.forEach(function (link) {
    const anchor = link.getAttribute('data-section-anchor');
    const section = document.getElementById(anchor);
    if (section) {
      sections.push({ link, section });
    }
  });

  if (sections.length === 0) return;

  function updateActive() {
    const viewportMid = window.innerHeight * 0.4;
    let activeSection = sections[0].section;

    sections.forEach(function ({ section }) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= viewportMid) {
        activeSection = section;
      }
    });

    sections.forEach(function ({ link, section }) {
      link.classList.toggle('is-active', section === activeSection);
    });
  }

  updateActive();
  window.addEventListener('scroll', updateActive, { passive: true });
})();
